import { FC, useEffect } from 'react';
// MUI
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
// Icons
import {
  CheckCircle as CheckCircleIcon,
  InfoOutlined as InfoOutlinedIcon
} from '@mui/icons-material';
// MixPanel
import Mixpanel from 'app/services/Mixpanel.service';
import MixpanelTracks from 'app/types/MixpanelTracks';

const SuccessPage:FC = () => {
  useEffect(() => {
    Mixpanel.track(MixpanelTracks.CampaignRecordsUploaded);
  }, []);

  const onClick = () => {
    window.location.href = '/';
  }

  return (
    <Box sx={{
      flexGrow: 1,
      bgcolor: '#f5f7fa',
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Card sx={{
        maxWidth: 600,
        width: '100%',
        p: 4,
        boxShadow: 3,
        borderRadius: 3,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <CheckCircleIcon color="success" sx={{ fontSize: { xs: 28, sm: 34 } }} />
          <Typography sx={{ fontWeight: 700, fontSize: { xs: 20, sm: 24 } }}>
            Files Received - We’re on it!
          </Typography>
        </Box>

        <CardContent>
          <Typography sx={{ fontSize: { xs: 14, sm: 16 }, mb: 2 }}>
          As soon as your report is ready, you’ll receive a link via email that takes you to your <b>secure  portal</b> — where you can use our comprehensive validation tools to confirm what the AI got right and easily spot any gaps or inaccuracies.
          </Typography>

          <Typography sx={{ fontSize: { xs: 14, sm: 16 }, mb: 4 }}>
            If the case progresses toward trial, our advanced tools are here to help. Build dynamic chronology calendars, interactive timelines, and detailed reports to support your legal strategy.
          </Typography>

          <Box sx={{
            p: 2,
            bgcolor: '#eef3f7',
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}>
            <InfoOutlinedIcon color="info" sx={{ mr: 1, mt: '3px' }} />
            <Box>
              <Typography variant="body2" color="text.secondary">
                You get the report and access to your portal for 7 days.
              </Typography>
              <Typography variant="body2" color="text.secondary" fontStyle="italic">
                *Extra AI reports are not available until you choose to activate the account.
              </Typography>
            </Box>
          </Box>

          <Box sx={{
            mt: 8,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Button
              variant="contained"
              size="large"
              onClick={onClick}
            >Go to Your Portal</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default SuccessPage;
